import { render, staticRenderFns } from "./Admin.vue?vue&type=template&id=189e7789&scoped=true"
import script from "./Admin.vue?vue&type=script&lang=ts"
export * from "./Admin.vue?vue&type=script&lang=ts"
import style0 from "./Admin.vue?vue&type=style&index=0&id=189e7789&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189e7789",
  null
  
)

export default component.exports